import { Breadcrumbs, styled, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export const BreadcrumbsStyled = styled(Breadcrumbs)(({ theme }) => ({
  '.MuiBreadcrumbs-ol': {
    flexWrap: 'nowrap',
  },
  '.MuiBreadcrumbs-li': {
    minWidth: 0,
  },
  '.MuiBreadcrumbs-separator': {
    margin: '0 8px',
    color: theme.palette.secondary.dark,
    svg: {
      display: 'block',
      width: '7px',
      height: '12px',
    },
  },
}));

const crumbTextStyles = {
  display: 'block',
  fontSize: '16px',
  lineHeight: '20px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} as const;

export const BreadcrumbText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'isCurrent',
})<{ isCurrent?: boolean }>(({ theme, isCurrent }) => ({
  ...crumbTextStyles,
  fontWeight: isCurrent ? 700 : 400,
  color: theme.palette.secondary.dark,
  cursor: 'default',
}));

export const BreadcrumbLink = styled(Link)(({ theme }) => ({
  ...crumbTextStyles,
  fontWeight: 400,
  color: theme.palette.secondary.dark,
  textDecoration: 'none',
  cursor: 'pointer',
  '&:hover': {
    color: theme.palette.primary.main,
  },
}));
